import { render, staticRenderFns } from "./ListDepartment.vue?vue&type=template&id=24f6c81c&scoped=true"
import script from "./ListDepartment.vue?vue&type=script&lang=js"
export * from "./ListDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6c81c",
  null
  
)

export default component.exports